module.exports = __webpack_public_path__ + "static/fipcbluesafari-004f6884801d6dc4806cad5a7088cf8e.jpeg";